import React from 'react';
import { Menu, Dropdown, Header, Grid, Segment, List, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import api from '../../../api';
import questImg from '../../../assets/img/questImg.png';

const estructurarElTextoLabels = [
  'Añadir información',
  'Comparar',
  'Delimitar',
  'Ejemplificar',
  'Expresar causa',
  'Expresar condición',
  'Expresar consecuencia',
  'Expresar finalidad',
  'Expresar oposición',
  'Hacer referencia al propio trabajo',
  'Introducir un tema',
  'Introducir una alternativa',
  'Introducir una excepción',
  'Ordenar',
  'Reenviar',
  'Reformular',
  'Resumir'
];

const referirseAlContenidoDeLaInvestigacionLabels = [
  'Definir y describir',
  'Denominar',
  'Establecer grupos',
  'Expresar cantidad',
  'Expresar frecuencia',
  'Expresar tiempo',
  'Presentar datos',
  'Presentar el objeto de estudio',
  'Presentar la metodología',
  'Presentar las conclusiones',
  'Presentar los objetivos'
];

const posicionarseYDirigirseAlLector = [
  'Atenuar',
  'Expresar necesidad',
  'Expresar una evaluación',
  'Hacer hincapié',
  'Indicar certeza',
  'Indicar la fuente',
  'Indicar posibilidad'
];

class BundlesPanel extends React.Component {
  constructor(props) {
    super(props);
    !this.props.discursiva ? this.state = {
        funcionesDiscursivas: [],
        funcionDiscursiva: '',
        renderFuncionesDiscursivas: false,
        showEmptyResult: false
      } : this.state = {
        funcionesDiscursivas: [],
        funcionDiscursiva: this.props.discursiva,
        renderFuncionesDiscursivas: true,
        showEmptyResult: false
      }
    
  }

  onClick = (e, data) => {
    api.formulas
      .getByFuncionDiscursiva(data.children)
      .then(funcionesDiscursivas => {
        let renderFuncionesDiscursivas;
        let showEmptyResult;
        
          if (funcionesDiscursivas.length > 0) {
            renderFuncionesDiscursivas = true;
          } else {
            showEmptyResult = true;
          }

        this.setState({
          funcionesDiscursivas,
          renderFuncionesDiscursivas,
          showEmptyResult,
          funcionDiscursiva: data.children
        });
      });
  };

  componentDidMount = () => {
    if(this.props.discursiva){
      api.formulas
      .getByFuncionDiscursiva(this.props.discursiva)
      .then(funcionesDiscursivas => {
        let renderFuncionesDiscursivas;
        let showEmptyResult;
        
          if (funcionesDiscursivas.length > 0) {
            renderFuncionesDiscursivas = true;
          } else {
            showEmptyResult = true;
          }
        
        this.setState({
          funcionesDiscursivas,
          renderFuncionesDiscursivas,
          showEmptyResult,
          funcionDiscursiva: this.props.discursiva
        });
      });
    }     
  };

  // TODO: refactorizar el dropdown (crear un json como source)
  render() {
    const {
      funcionesDiscursivas,
      renderFuncionesDiscursivas,
      showEmptyResult,
      funcionDiscursiva
    } = this.state;
    
    return (
      <div>
        <Grid className="mystyle7">
          <h3>Búsqueda por función discursiva</h3> 
          <Image 
            src={questImg} 
            as='a' 
            size='medium' 
            href='https://www.youtube.com/watch?v=rLTbrnCVApc' 
            target='blank_' 
            avatar
            className="mystyle8"
          />
        </Grid>
        <Grid textAlign="center" columns="equal">
          <Grid.Column>
            <Menu vertical fluid>
              <Dropdown
                text="Estructurar el texto"
                pointing="left"
                className="link item"
              >
                <Dropdown.Menu>
                  {estructurarElTextoLabels.map((label, key) => (
                    <Dropdown.Item key={key} onClick={this.onClick}>
                      {label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                text="Referirse al contenido de la investigación"
                pointing="left"
                className="link item"
              >
                <Dropdown.Menu>
                  {referirseAlContenidoDeLaInvestigacionLabels.map((label, key) => (
                    <Dropdown.Item key={key} onClick={this.onClick}>
                      {label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                text="Posicionarse y dirigirse al lector"
                pointing="left"
                className="link item"
              >
                <Dropdown.Menu>
                  {posicionarseYDirigirseAlLector.map((label, key) => (
                    <Dropdown.Item key={key} onClick={this.onClick}>
                      {label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Menu>
          </Grid.Column>

          <Grid.Column>
            {this.state.funcionDiscursiva && (
              <div>
                <Header as="h3" block attached="top">
                  Función discursiva
                </Header>
                <Segment attached>{this.state.funcionDiscursiva}</Segment>
              </div>
            )}
          </Grid.Column>
        </Grid>

        {renderFuncionesDiscursivas && (
          <Header as="h3" block attached="top">
            Fórmulas
          </Header>
        )}
        {renderFuncionesDiscursivas && (
          <Segment attached>
            <List>
              {funcionesDiscursivas.map(discursiva => (
                (discursiva.tipoCorpus === "Expertos") ?
                <List.Item
                  key={discursiva.id}
                  as={Link}
                  target="_blank"
                  to={`/search/formulas/${discursiva.id}`}
                >
                  {discursiva.texto}
                </List.Item> :
                <span className="myStyle3"></span>
              ))}
            </List>
          </Segment>
        )}

        {showEmptyResult && (
          <Header as="h3" block attached="top">
            No se encuentran resultados
          </Header>
        )}
        {showEmptyResult && (
          <Segment attached>
            No se encuentran resultados para la función discursiva &nbsp;
            <b>"{funcionDiscursiva}"</b>
          </Segment>
        )}
      </div>
    );
  }
}

export default BundlesPanel;
